<template>
  <y-wrapper @back="handleBack">
    <template slot="nav">
      <div class="nav-wrap">
        <div class="left">教练员注册变更申请</div>
        <div class="right">
          <div class="btn active" @click="handleAlterationList">
            注册记录
          </div>
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="main-content">
        <div class="search-wrap">
          <div class="left-search">
            <!--<select-->
              <!--name="transfer_item_status"-->
              <!--class="select"-->
              <!--v-model="searchForm.transfer_item_status"-->
              <!--@change="selecChange"-->
            <!--&gt;-->
              <!--<option value="">全部状态</option>-->
              <!--<option v-for="(item, index) in selectAlterOrgStatus"-->
                                        <!--:key="index"-->
                                        <!--:value="item.key">{{ item.value }}-->
                                <!--</option>-->
            <!--</select>-->
          </div>
          <div class="right-search">
            <div class="input-wrap">
              <input
                type="text"
                placeholder="请输入搜索内容"
                v-model.lazy="searchForm.keywords"
                @keyup.enter="inputChange"
              />
              <div
                v-show="searchForm.keywords != ''"
                class="close"
                @click="hideIcon"
              >
                <v-icon name="regular/times-circle" scale="1.2"></v-icon>
              </div>
              <div class="searchBtn" @click="getRequest">搜索</div>
            </div>
          </div>
        </div>
        <div class="content-wrap">
          <yioks-loading v-show="isLoading"></yioks-loading>
          <template v-if="!isLoading">
            <div class="scroll_wrap">
              <div class="scro-wrapper">
                <vue-scroll :ops="vuescrollOpt">
                <div class="list_content" v-if="pageList.length">
                  <div
                    class="item"
                    v-for="(item, index) in pageList"
                    :key="index"
                  >
                    <div class="item_left">
                      <p class="name">{{ item.transfer_item_name }}</p>
                      <p class="tiem">
                        <span class="box">
                          教练员注册申请窗口期： {{ item.coach_submit_start | time(false)}} 至 {{ item.coach_submit_end | time(false)}}
                        </span>
                      </p>
                      <p class="tiem">
                        <span class="box">
                          转入协会审核截止日期： {{ item.enter_org_audit_end | time(false)}}
                        </span>
                      </p>
                      <p class="tiem">
                        <span class="box">
                          转出协会审核截止日期： {{ item.leave_org_audit_end | time(false)}}
                        </span>
                      </p>
                    </div>
                    <div class="item_right">
                      <div style="display:flex">
                        <div class="btn sign suc" v-if="item.showRecon"  @click="lookOver(item.showReconsider)" style="margin-right:10px">查看复核申请</div>
                        <div class="btn sign suc" v-if="item.btnAvi"  @click="handleSign(item)">点击申请注册变更</div>
                        <div class="btn sign deny" v-else >注册变更窗口已关闭</div>
                        <div class="seletImg" v-if="item.showSelect" @click="handleFindStatus(item)" title="点击查看审核结果"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="empty" style="margin-top:200px" v-else>
                  <yioks-empty :h="'100%'" :tips="'注册窗口预计于2023年开放，请耐心等候相关通知。'"></yioks-empty>
                </div>
              </vue-scroll>
              </div>
            </div>
          </template>

          <div class="alteration-status-dialog">
            <el-dialog
              title=""
              :visible.sync="isShowAlterationDialog"
              width="450px"
              top="20vh"
              :before-close="alterationDialogCloseBefore">
              <div class="record-list">
                <div class="record-item" >
                  <p>审核状态： <span>{{ alterationRecord.status | alterStatusForCoachToStudent }}</span></p>
                  <div class="record-status" v-if="msg && !['EnterOrgAudit','LeaveOrgAudit'].includes(alterationRecord.status)">
                    <span>审核理由：</span>
                    <p>{{msg}}</p>
                  </div>
                  <p style="margin-top:15px" v-if="Fuyirow.showFuyi">教练员可在变更申请被拒绝后的 5 个工作日内向中国足协提出复核申请，中国足协将在收到申请后的 10 个工作日内进行复核并通过教练员培训管理系统进行反馈；只有一次提交复核申请机会。<span style="cursor:pointer;color:#4CD964" @click="goFuyi(Fuyirow)">点击申请复核</span></p>
                </div>
              </div>
            </el-dialog>
          </div>

          <template v-if="isShowApplyList">
            <alteration-apply-list
              :isShow.sync="isShowApplyList"
              :applyList="applyList"
            ></alteration-apply-list>
          </template>
          <el-dialog
            title="提示"
            :visible.sync="isShowSelfInfo"
            width="450px"
            :close-on-click-modal="false"
            custom-class="self-tips-complete"
            :top="'20vh'"
          >
            <div class="tips-for-complete">
              <div class="little-tips">
                如您需要变更注册协会，可在此提交申请，申请前请务必与目标转入协会进行联系了解相关要求。
              </div>
              <div class="btns">
                <el-button type="primary" @click="isShowSelfInfo = false">我知道了</el-button>
                <el-button type="primary" @click="goZhuce">申请注册变更</el-button>
              </div>
    
            </div>
          </el-dialog>
          <div v-if="t_show">
            <details-dialog
              :isShowAddDialog.sync="t_show"
              :dialogData="documentDialog"
            />
          </div>
        </div>
      </div>
    </template>
  </y-wrapper>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";
import { getTransferItemList, getAlterationAuditList } from "@/api/system_manager/api";
import { getAlterationStatus } from "@/api/training_student/api";
import createScrollOpt from "@/assets/js/vuescrollOption";
import { alterStatusForCoachToStudent } from "@/assets/js/yioksFilters";
import {
  selectAlterOrgStatus,
} from "@/assets/js/select";
import { getNowTime } from "@/assets/js/utils";
export default {
  components: {
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "alteration-apply-list": () => import("@/views/system_manager/orgAlteration/components/alterationApplyList"),
    "details-dialog": () => import("@/views/system_manager/orgAlteration/components/ReconsiderSeeDetails"),
  },

  data() {
    return {
      searchForm: {
        transfer_item_status: "",
        keywords: "",
      },
      vuescrollOpt: createScrollOpt(),
      ops: ops(),
      isLoading: false,
      pageList: [],
      isShowAlterationDialog: false,
      alterationRecord: {},
      msg: '',
      selectAlterOrgStatus,
      applyList: [],
      isShowApplyList: false,
      isShowSelfInfo: false,
      row:{},
      Fuyirow:{},
      documentDialog: {},
      t_show: false,
    };
  },

  filters: {
    alterStatusForCoachToStudent,
  },

  created() {
    this.setQuery();
    this.loadPageList();
  },

  methods: {
    lookOver(row) {
      this.documentDialog = row;
      this.t_show = true;
    },
    handleBack() {
      this.$router.push("/");
    },
    setQuery() {
      const {transfer_item_status, keywords } = this.$route.query;
      transfer_item_status && (this.$set(this.searchForm, 'transfer_item_status', transfer_item_status))
      keywords && (this.$set(this.searchForm, 'keywords', keywords))
    },

    // 搜索
    selecChange() {
      this.changeQuery(true)
    },

    inputChange() {
      this.changeQuery(true);
    },
    getRequest() {
      this.changeQuery(true);
    },
    hideIcon() {
      this.$set(this.searchForm, "keywords", "");
      this.getRequest();
    },
    changeQuery(status) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          ...this.searchForm,
        }
      })
      this.loadPageList()
    },

    loadPageList() {
      const { keywords, transfer_item_status } = this.$route.query;

      const paramsData = {
        keywords,
        transfer_item_status,
      };
      this.isLoading = true;
      getTransferItemList(paramsData)
        .then(({ data }) => {
          this.isLoading = false;
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          const { list } = data.result;
          this.pageList = list.map(item => {
            const newDate = getNowTime();
            let btnAvi = newDate <= item.coach_submit_end && newDate >= item.coach_submit_start
            return {
              ...item,
              btnAvi: btnAvi,  // 逻辑有点问题。。。
              // btnAvi: true,
            }
          });
        })
        .catch((err) => {
          this.isLoading = false;
          console.error("err", err);
        });
    },

    // 申请注册
    handleSign(row) {
      this.isShowSelfInfo = true
      this.row = row;

    },
    goZhuce(){
      const {transfer_item_uuid, btnAvi} = this.row;
      if(btnAvi){
        this.$router.push({
          path:'alter_avi_details',
          query:{
            transfer_item_uuid:transfer_item_uuid
          }
        })
      }
    },
    goFuyi(row){
      const {recordUuid} = row;
      this.$router.push({
        path: 'alter_avi_fuyi',
        query: {
          record_uuid: recordUuid
        }
      })
    },

    async handleFindStatus(row) {
      const {transfer_item_uuid} = row;
      this.Fuyirow = row;
      try {
        const queryData = {
          transfer_item_uuid: transfer_item_uuid,
        };
        const { data } = await getAlterationStatus(queryData);
        this.alterationRecord = data.result.record;
        this.msg = data.result.msg;
        this.isShowAlterationDialog = true;
      } catch(err) {
        console.error('err', err)
      }
    },

    alterationDialogCloseBefore() {
      this.isShowAlterationDialog = false;
    },

    handleAlterationList() {
      getAlterationAuditList()
        .then(({data}) => {
          if(data.status !== 0) {
            this.$message.error(data.msg)
            return
          }
          this.applyList = data.result;
          this.isShowApplyList = true;
        })
        .catch(err => {
          console.log('err', err)
        })
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/yioksPage'
.nav-wrap
  flex 1
  box-sizing border-box
  padding 0 30px 0 0
  display flex
  justify-content space-between
  align-items center
  font-size $font_size_big
  .right
    font-size $font_size_big
    .btn
      padding 5px 15px
      cursor pointer
      user-select none
      &.active
        background-color $color_suc
      &+.btn
        margin-left 10px
.main-content
  flex 1 1 auto
  padding-top 25px
  box-sizing border-box
  width 100%
  background-color $block_bg_color_base
  .search-wrap
    display flex
    justify-content space-between
    align-items center
    height 40px
    margin 0 40px
    .left-search
      height 100%
      .select
        width 155px
        height 100%
        padding 0 15px
        font-size $font_size_medium
        color $color_black
        outline none
    .right-search
      height 100%
      .input-wrap
        width 290px
        height 100%
        display flex
        justify-content space-between
        align-items center
        position relative
        input
          width 200px
          height 100%
          padding 0 20px
          font-size $font_size_medium
          color $color_black
        .close
          position absolute
          right 100px
          top 10px
          color $color_info
          cursor pointer
    .searchBtn
      width 90px
      height 100%
      display flex
      justify-content center
      align-items center
      font-size 20px
      background-color $color_suc
      cursor pointer
      user-select none
.scroll_wrap
  display block
  width 100%
  height 100%
  .list_content
    display block
    padding 0 30px
    .item
      display flex
      align-items flex-end
      padding 20px 0 34px
      border-bottom 1px solid #ccc
      &+.item
        // margin-top 15px
      .item_left
        display flex
        flex-direction column
        flex 1
        .name
          margin-bottom 10px
          font-size 18px
          line-height 18px
          &.gray
            color #b2b2b2
        .tiem
          .box
            margin-right 10px
            font-size 14px
            line-height 14px
            color #b2b2b2
            &:last-child
              margin-right 0
      .item_right
        // flex-direction column
        align-items: center
        flex none
        .fuyi
          margin-bottom 5px
          color $color_suc
          cursor pointer
        .selected-result
          margin-bottom 5px
        .btn
          width 155px
          display: flex
          align-items: center
          justify-content: center
          user-select none
          border-radius: 3px
          &.sign
            padding 10px 10px
          &.suc
            cursor pointer
            background-color $color_suc
          &.deny
            cursor: not-allowed
            background-color #b2b2b2
        .showRes
          margin-right 48px
        .seletImg
          width 40px
          height 40px
          background url('../../../assets/images/registration_signUp_sele.png')
          background-size 100% 100%
          margin-left 10px
          cursor pointer
          &.gray
            background url('../../../assets/images/registration_signUp_gray.png')
            background-size 100% 100%
      .name
        display block
        font-size $font_size_big
        font-weight bolder

.scro-wrapper
  height: 550px
  padding 10px 5px
  box-sizing: border-box


.seletImg
  width 40px
  height 40px
  background url('../../../assets/images/registration_signUp_sele.png')
  background-size 100% 100%
  margin-left 10px
  cursor pointer
  &.gray
    background url('../../../assets/images/registration_signUp_gray.png')
    background-size 100% 100%

.record-list
  padding 10px 10px 20px 20px
.record-status
  display: flex
  margin-top 15px
  span
    width 74px
  p
    flex 1
    word-break: break
.tips-for-complete
  .little-tips
    height 80px
    display flex
    justify-content: center
    align-items: center
    margin-bottom: 20px
    font-size: 16px
    text-align: center
    line-height 2em
    padding 0 15px
  .btns
    display flex
    align-items center
    justify-content: space-around
/deep/.el-dialog__body
  padding 10px 20px 20px
</style>
